import { render, staticRenderFns } from "./add-employee.vue?vue&type=template&id=c5ad30c4&scoped=true"
import script from "./add-employee.vue?vue&type=script&lang=ts"
export * from "./add-employee.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5ad30c4",
  null
  
)

export default component.exports